export default {
  GET_MAIL_TEMPLATES(state) {
    return state.mail_templates.results
  },
  GET_SMS_TEMPLATE_FIELDS(state) {
    return state.mail_template_fields
  },
  GET_AUTO_MAILS(state) {
    return state.auto_mails
  },
}
